var _defs, _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeroBg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1100,
    viewBox: "0 0 1920 1100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "lineGrad1",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4f8cff",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#22d3ee",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#a855f7",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lineGrad2",
    x1: "100%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#a855f7",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#4f8cff",
    stopOpacity: 0.35
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "nodeGlowBlue",
    cx: "50%",
    cy: "50%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4f8cff",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#4f8cff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "nodeGlowCyan",
    cx: "50%",
    cy: "50%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#22d3ee",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#22d3ee",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "nodeGlowPurple",
    cx: "50%",
    cy: "50%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#a855f7",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#a855f7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "softBlur",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("pattern", {
    id: "dots",
    width: 42,
    height: 42,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 1.4,
    fill: "#8a93b8"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1100,
    fill: "url(#dots)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeWidth: 1.4,
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 80 140 H 320 V 60 H 560",
    stroke: "url(#lineGrad1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 120 320 H 260 V 420 H 460 V 360 H 700",
    stroke: "url(#lineGrad2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1400 90 H 1620 V 220 H 1860",
    stroke: "url(#lineGrad1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1320 380 H 1180 V 480 H 980 V 520",
    stroke: "url(#lineGrad2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1500 620 H 1700 V 760 H 1500 V 860",
    stroke: "url(#lineGrad1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 200 600 H 380 V 740 H 200 V 880",
    stroke: "url(#lineGrad2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 760 80 V 220 H 920",
    stroke: "url(#lineGrad1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1040 760 H 1240 V 900",
    stroke: "url(#lineGrad2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 60 980 H 280 V 1060",
    stroke: "url(#lineGrad1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1640 920 H 1820 V 1040 H 1640",
    stroke: "url(#lineGrad2)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#softBlur)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 140,
    r: 5,
    fill: "url(#nodeGlowBlue)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 560,
    cy: 60,
    r: 4,
    fill: "url(#nodeGlowCyan)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260,
    cy: 320,
    r: 5,
    fill: "url(#nodeGlowPurple)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 460,
    cy: 420,
    r: 4,
    fill: "url(#nodeGlowBlue)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1620,
    cy: 90,
    r: 5,
    fill: "url(#nodeGlowCyan)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1860,
    cy: 220,
    r: 4,
    fill: "url(#nodeGlowPurple)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1180,
    cy: 380,
    r: 5,
    fill: "url(#nodeGlowBlue)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 980,
    cy: 480,
    r: 4,
    fill: "url(#nodeGlowCyan)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1700,
    cy: 620,
    r: 5,
    fill: "url(#nodeGlowPurple)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1500,
    cy: 760,
    r: 4,
    fill: "url(#nodeGlowBlue)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 380,
    cy: 600,
    r: 5,
    fill: "url(#nodeGlowCyan)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 740,
    r: 4,
    fill: "url(#nodeGlowPurple)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 920,
    cy: 220,
    r: 5,
    fill: "url(#nodeGlowBlue)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1240,
    cy: 760,
    r: 4,
    fill: "url(#nodeGlowCyan)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 980,
    r: 4,
    fill: "url(#nodeGlowPurple)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1820,
    cy: 920,
    r: 5,
    fill: "url(#nodeGlowBlue)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "url(#lineGrad1)",
    strokeWidth: 1.2,
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "960,260 1010,290 1010,350 960,380 910,350 910,290"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1060,300 1110,330 1110,390 1060,420 1010,390 1010,330"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "860,300 910,330 910,390 860,420 810,390 810,330"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroBg);
export default __webpack_public_path__ + "static/media/hero-bg.129f86087efac799ab08485b70caf739.svg";
export { ForwardRef as ReactComponent };